export const isOfferInBonuses = (offerPublicId, bonuses) => {
  try {
    return bonuses.some((x) => x.offerPublicId === offerPublicId)
  } catch (exception) {
    return false
  }
}

export const offerById = (offerPublicId, bonuses) => {
  try {
    return bonuses.find((x) => x.offerPublicId === offerPublicId)
  } catch (exception) {
    return undefined
  }
}

export const bonusBalanceForClient = (clientId, bonuses) => {
  try {
    return bonuses.reduce((accumulator, bonus) => {
      // ensure we even have clients to operate on
      if (!bonus.applicableClients) {
        return accumulator
      }

      // ensure we have only a single client
      if (bonus.applicableClients.length !== 1) {
        return accumulator
      }

      // ensure the sole client is the one we want
      if (bonus.applicableClients[0].toLowerCase() !== clientId) {
        return accumulator
      }

      // if we passed all the previous checks then we are safe to add this bonues to the total
      accumulator = accumulator + bonus.balance

      return accumulator
    }, 0)
  } catch (exception) {
    return 0
  }
}

export const hasBonuses = (bonuses) => {
  return bonuses.find((bonus) => bonus.balance > 0)
}

export const totalBonusAmount = (bonuses) => {
  if (!bonuses) {
    return 0
  }

  const total = bonuses.reduce((accumulator, bonus) => {
    return accumulator + bonus.balance
  }, 0)

  return total
}

const bonusClients = (bonuses) => {
  const clients = bonuses.reduce((accumulator, bonus) => {
    // handle unexpected data
    if (!bonus.applicableClients || bonus.applicableClients[0] === undefined) {
      return accumulator
    }

    // prevent duplicate client entries
    if (accumulator.find((item) => item === bonus.applicableClients[0]) !== undefined) {
      return accumulator
    }

    // multiple clients means the bonus can be used on any property
    if (!accumulator['shgn'] && bonus.applicableClients.length > 1) {
      accumulator.push('shgn')
      return accumulator
    }
    // single clients get their own category

    accumulator.push(bonus.applicableClients[0])

    return accumulator
  }, [])

  return clients
}

export const bonusTotalsByClient = (bonuses) => {
  if (!bonuses) {
    return []
  }

  const clients = bonusClients(bonuses)

  const totalsByClient = clients.reduce((accumulator, client) => {
    accumulator.push({ name: client, balance: 0 })
    return accumulator
  }, [])

  bonuses.forEach((bonus) => {
    if (!bonus.applicableClients || bonus.applicableClients.length === 0) {
      return
    }

    const clientName = bonus.applicableClients.length === 1 ? bonus.applicableClients[0] : 'shgn'
    const client = totalsByClient.find((client) => client.name === clientName)
    client.balance += bonus.balance
  })

  return totalsByClient
}

export const getMostRecentBonus = (bonuses) => {
  const mostRecentBonuses = bonuses.sort(function (a, b) {
    a = new Date(a.claimedAt)
    b = new Date(b.claimedAt)
    return a > b ? -1 : 1
  })
  return mostRecentBonuses[0]
}



// WEBPACK FOOTER //
// ./src/tools/wallet.js